import AuthHelper from '@/helpers/auth';

import AuctionLayout from '@/components/layouts/AuctionLayout';

import Auction from '@/components/views/Auction/Auction';

// auction items
import AuctionItems from '@/components/views/Auction/Item/ItemList';
import AuctionItemForm from '@/components/views/Auction/Item/Form/ItemForm';
import AuctionItem from '@/components/views/Auction/Item/Item';
import AuctionItemsOrders from '@/components/views/Auction/Item/ItemOrder';

// auction bids
import AuctionBid from '@/components/views/Auction/Bid/BidList';
import AuctionBidForm from '@/components/views/Auction/Bid/BidForm';
import AuctionPendingBid from '@/components/views/Auction/PendingBid/PendingBidList';
import AuctionPendingBidForm from '@/components/views/Auction/PendingBid/PendingBidForm';

// auction persons
import AuctionSellers from '@/components/views/Auction/Seller/SellerList';
import AuctionSeller from '@/components/views/Auction/Seller/Seller';
import AuctionBuyers from '@/components/views/Auction/Buyer/BuyerList';
import AuctionBuyer from '@/components/views/Auction/Buyer/Buyer';

import AuctionPhotos from '@/components/views/Auction/Photos';
import AuctionLists from '@/components/views/Auction/Lists';

// helpers
import i18n from '@/language/';

const auctionRoutes = {
	path: '',
	beforeEnter: AuthHelper.requireAuth,
	component: AuctionLayout,
	children: [{
			path: '/auction/:auctionId',
			name: 'auction',
			component: Auction,
			meta: {
				title: i18n.t('common.auction')
			}
		},

		/* Items */
		{
			path: '/auction/:auctionId/items',
			name: 'itemList',
			component: AuctionItems,
			meta: {
				title: i18n.t('common.items')
			}
		},
		{
			path: '/auction/:auctionId/items/add',
			name: 'itemAdd',
			component: AuctionItemForm,
			meta: {
				title: i18n.t('item.addPageTitle')
			}
		},
		{
			path: '/auction/:auctionId/items/:itemId',
			name: 'item',
			component: AuctionItem,
			meta: {
				title: i18n.t('common.item')
			}
		},
		{
			path: '/auction/:auctionId/items/:itemId/edit',
			name: 'itemEdit',
			component: AuctionItemForm,
			meta: {
				title: i18n.t('item.editPageTitle', { itemNumber: null })
			}
		},
		{
			path: '/auction/:auctionId/item_orders',
			name: 'itemOrders',
			component: AuctionItemsOrders,
			meta: {
				title: i18n.t('item.orderingCounts')
			}
		},
		{
			path: '/auction/:auctionId/photos',
			name: 'auctionPhotos',
			component: AuctionPhotos,
			meta: {
				title: i18n.t('auction.photos')
			}
		},
		{
			path: '/auction/:auctionId/lists',
			name: 'auctionLists',
			component: AuctionLists,
			meta: {
				title: i18n.t('auction.lists')
			}
		},

		/* Bids */
		{
			path: '/auction/:auctionId/bids',
			name: 'bidList',
			component: AuctionBid,
			meta: {
				title: i18n.t('common.bids')
			}
		},
		{
			path: '/auction/:auctionId/bids/item/:itemId/bid/:bidId/edit',
			name: 'bidEdit',
			component: AuctionBidForm,
			meta: {
				title: i18n.t('bid.edit')
			}
		},

		/* Pending Bids */
		{
			path: '/auction/:auctionId/pending-bids',
			name: 'pendingBidList',
			component: AuctionPendingBid,
			meta: {
				title: i18n.t('common.pendingBids')
			}
		},
		{
			path: '/auction/:auctionId/pending-bids/item/:itemId/pending-bid/:pendingBidId/edit',
			name: 'pendingBidEdit',
			component: AuctionPendingBidForm,
			meta: {
				title: i18n.t('pendingBid.editTitle')
			}
		},
		{
			path: '/auction/:auctionId/pending-bids/item/:itemId/pending-bid/add',
			name: 'pendingBidAdd',
			component: AuctionPendingBidForm,
			meta: {
				title: i18n.t('pendingBid.addTitle')
			}
		},

		/* Sellers */
		{
			path: '/auction/:auctionId/sellers',
			name: 'auctionSellers',
			component: AuctionSellers,
			meta: {
				title: i18n.t('common.sellers')
			}
		},
		{
			path: '/auction/:auctionId/seller/:personId',
			name: 'auctionSeller',
			component: AuctionSeller,
			meta: {
				title: i18n.t('auction.activity')
			}
		},

		/* Buyers */
		{
			path: '/auction/:auctionId/buyers',
			name: 'auctionBuyers',
			component: AuctionBuyers,
			meta: {
				title: i18n.t('common.buyers')
			}
		},
		{
			path: '/auction/:auctionId/bid_number/:bidNumber',
			name: 'auctionBuyer',
			component: AuctionBuyer,
			meta: {
				title: i18n.t('auction.activity')
			}
		}
	]
};

export default auctionRoutes


// WEBPACK FOOTER //
// ./src/router/routes/auction-routes.js